module.exports = __webpack_public_path__ + "img/vip_9610141.webp";